import React from "react";
import { host } from "../libs/webRTC";
import axios from "../libs/httpClient";
import '../styles/ClientGenerate.css';
import { Box } from "@mui/material";
import ClientForm from "../components/ClientForm";
import NavStruct from "../components/NavStruct";
import { useUser } from '../context/UserContext';

axios.defaults.withCredentials = true;


function postData(data) {
    axios.post('/api/service/session/generate', data)
        .then(res => {
            if (res.data && res.data.success)
                window.location = (`/generateSession/client/${res.data.session_id}`);
            else {
                alert("Ошибка создания сессии. Попробуйте выйти и авторизоваться повторно или попробуйте позже.")
                window.location = (`/generateSession`);
            }
        });
}


export default function ClientGenerate() {
    const userContext = useUser();
    let path = window.location.href;
    let parsed = path.split('/')

    const createSession = (room) => {
        // We can get all user and session info (except 'room', 'subject' and 'title') from DB in backend
        // but for some reasons - group's still here (teachers/admins haven't group in DB)
        const group = document.getElementById("group").value || userContext.get_group();
        postData({ group, room, subject: document.getElementById("subject")?.innerText, title: document.getElementById("title")?.value });
    }

    return (
        <Box>
            <Box sx={{ margin: '20px 0px 0px 50px' }}>
                <NavStruct />
            </Box>
            <ClientForm createSession={createSession} roomId={parsed.indexOf('generateSession') !== parsed.length - 1 ? parsed.at(-1) : null} />
        </Box>
    );
}

